import '../scss/main.scss';

import ObjectFitImages from 'object-fit-images';
import naja from 'naja';
import netteForms from 'nette-forms';
import HandelModal from './components/Modal';
import Menu from './components/Menu';
import Form from './components/Form';
import ProductGrid from './components/ProductGrid';
import Accordion from './components/Accordion';
import ShowMore from './components/ShowMore';
import ScrollTo from './components/ScrollTo';
import Filter from './components/Filter';
import Counter from './components/Counter';
import ProductInfo from './components/ProductInfo';
import Score from './components/Score';
import Helpers from "./components/Helpers";
import Flashes from "./components/Flashes";
import BlogMenu from "./components/BlogMenu";
import InfoBar from "./components/InfoBar";
import Ares from "./components/Ares";
import OrderPerson from "./components/OrderPerson";
import OrderCart from "./components/OrderCart";
import InvisibleRecaptcha from "./components/InvisibleRecaptcha";
import LoadingIndicatorExtension from "./components/naja/LoadingIndicatorExtension";

window.Nette = netteForms;

document.addEventListener('DOMContentLoaded', naja.initialize.bind(naja));
netteForms.initOnLoad();

window.addEventListener('DOMContentLoaded', (event) => {
    naja.registerExtension(new LoadingIndicatorExtension('#globalLoadingIndicator'));
    Menu.init();
    ObjectFitImages();
    HandelModal.init();
    HandelModal.a11y();
    ProductGrid.init();
    Form.init();
    Form.handleChecked();
    Form.handleFixedLabel();
    Accordion.init();
    ShowMore.init();
    ShowMore.hiddenItems();
    ScrollTo.init();
    Filter.init();
    Counter.init();
    ProductInfo.init();
    ProductInfo.scrollToProductInfo();
    ProductInfo.handleExternalTriggers();
    Score.init();
    Helpers.handleCheckboxes();
    Flashes.init();
    BlogMenu.init();
    InfoBar.init();
    Ares.init();
    OrderPerson.init();
    OrderCart.init();
    InvisibleRecaptcha.init();
    ObjectFitImages();
});
